import React from 'react';
import { Play } from 'lucide-react';
import { Button } from './ui/button';

const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Content */}
          <div className="space-y-6">
            <div className="inline-block bg-[#E94B3C]/10 text-[#E94B3C] px-4 py-2 rounded-full text-sm font-semibold">
              ABOUT US
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-[#2E3C5B] leading-tight">
              India's Leading Laptop Service Provider
            </h2>
            
            <div className="w-24 h-1 bg-[#E94B3C] rounded-full"></div>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              EBR Systems & Services was established in 2007 with a vision to provide world-class laptop repair and sales services across India. With over 18 years of experience, we have become the trusted choice for thousands of customers.
            </p>
            
            <p className="text-lg text-gray-600 leading-relaxed">
              Our team of certified technicians specializes in chip-level repairs, data recovery, and genuine spare parts replacement for all major laptop brands. We combine technical expertise with exceptional customer service.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full mt-2"></div>
                <p className="text-gray-700"><span className="font-semibold text-[#2E3C5B]">Certified Technicians:</span> All our staff are factory-trained and certified</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full mt-2"></div>
                <p className="text-gray-700"><span className="font-semibold text-[#2E3C5B]">Genuine Parts:</span> We use only original manufacturer-approved components</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full mt-2"></div>
                <p className="text-gray-700"><span className="font-semibold text-[#2E3C5B]">Quick Turnaround:</span> Most repairs completed within 24-48 hours</p>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-2 h-2 bg-[#E94B3C] rounded-full mt-2"></div>
                <p className="text-gray-700"><span className="font-semibold text-[#2E3C5B]">Warranty Support:</span> 6-month warranty on all repairs and parts</p>
              </div>
            </div>
            
            <Button 
              size="lg"
              className="bg-[#2E3C5B] hover:bg-[#1f2a3f] text-white border-0 shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
            >
              Learn More About Us
            </Button>
          </div>

          {/* Right - Image & Video */}
          <div className="relative group">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1768633647910-7e6fb53e5b0f"
                alt="Professional technicians at work"
                className="w-full h-[600px] object-cover transform group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2E3C5B]/80 via-transparent to-transparent"></div>
              
              {/* Play Button Overlay */}
              <div className="absolute inset-0 flex items-center justify-center">
                <button className="w-20 h-20 bg-[#E94B3C] rounded-full flex items-center justify-center shadow-2xl hover:bg-[#d43d2c] hover:scale-110 transition-all duration-300 group/play">
                  <Play className="text-white ml-1" size={32} fill="white" />
                </button>
              </div>
              
              {/* Bottom Text */}
              <div className="absolute bottom-8 left-8 right-8 text-white">
                <h3 className="text-2xl font-bold mb-2">Watch Our Story</h3>
                <p className="text-gray-200">See how we've transformed laptop repair services in India</p>
              </div>
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-[#E94B3C]/20 rounded-full blur-2xl -z-10"></div>
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-[#2E3C5B]/20 rounded-full blur-2xl -z-10"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
